export default "__VITE_ASSET__Y8iOlden__"